import React, { memo, useCallback, useState } from 'react';
import styled from 'styled-components/native';
import FilterMenuIcon from '../../../../assets/icons/analytics/menu.svg';
import { setFilterBottomSheetOpen } from '../../../../store/analytics/analytics.slice';
import { useDispatch } from 'react-redux';
import { calcHeight, calcWidth } from '../../../../utils/dimensions';

const HIT_SLOP = {
  top: 10,
  left: 10,
  bottom: 10,
  right: 10,
};

const FilterMenu = () => {
  const dispatch = useDispatch();

  const [isActive, setIsActive] = useState(false);

  const handleMenuOpen = useCallback(() => {
    setIsActive(false);
    dispatch(setFilterBottomSheetOpen(true));
  }, [dispatch]);

  const handlePressIn = useCallback(() => {
    setIsActive(true);
  }, []);

  return (
    <>
      <S.Container>
        <S.FilterMenuButton
          hitSlop={HIT_SLOP}
          isActive={isActive}
          onPressIn={handlePressIn}
          onPressOut={handleMenuOpen}
        >
          <FilterMenuIcon />
        </S.FilterMenuButton>
      </S.Container>
    </>
  );
};

const S = {
  Container: styled.View``,
  FilterMenuButton: styled.TouchableOpacity<{ isActive: boolean }>`
    width: ${calcWidth(32)}px;
    height: ${calcHeight(28)}px;
    background-color: ${({ theme, isActive }) => (isActive ? theme.colors.lightBlue : 'transparent')};
    border-radius: 4px;
    align-items: center;
    justify-content: center;
  `,
};

export default memo(FilterMenu);
